<section class="p-2 p-md-4">
  <div class="card mb-4">
    <div class="card-header bg-white">
      <h3>Dados da consulta</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-lg-6 p-2">
          <label for="consulta">Consulta</label>
          <div class="d-flex align-items-center autocomplete-container">
            <input [inputFormatter]="inputConsultaFormat" (selectItem)="addFiltroConsulta($event)"
              [(ngModel)]="consultaSelecionada" [ngbTypeahead]="pesquisaConsulta" [resultTemplate]="rt_consulta"
              id="pesquisaConsulta" type="text" class="form-control input-validate"
              [formControl]="formDados.controls.consulta" [value]="valueConsulta">
            <button *ngIf="consultaSelecionada" (click)="removeFiltroConsulta()" class="btn btn-xs btn-danger btn-icon">
              <i class="mdi mdi-close"></i>
            </button>
          </div>
          <ng-template #rt_consulta let-r="result" let-t="term">
            <ngb-highlight [result]="r.nome" [term]="t"></ngb-highlight>
          </ng-template>
          <app-msg-erro [control]="formDados.controls.consulta"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-6 p-2">
          <label for="fornecedor">Fornecedor</label>
          <div class="d-flex align-items-center autocomplete-container">
            <input [inputFormatter]="inputFornecedorFormat" (selectItem)="addFiltroFornecedor($event)"
              [(ngModel)]="fornecedorSelecionado" [ngbTypeahead]="pesquisaFornecedor" [resultTemplate]="rt_fornecedor"
              id="pesquisaFornecedor" type="text" class="form-control input-validate"
              [formControl]="formDados.controls.fornecedor" [value]="valueFornecedor">
            <button *ngIf="fornecedorSelecionado" (click)="removeFiltroFornecedor()"
              class="btn btn-xs btn-danger btn-icon">
              <i class="mdi mdi-close"></i>
            </button>
          </div>
          <ng-template #rt_fornecedor let-r="result" let-t="term">
            <ngb-highlight [result]="r.nome" [term]="t"></ngb-highlight>
          </ng-template>
          <app-msg-erro [control]="formDados.controls.fornecedor"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-6 p-2">
          <label for="requisicao">Tipo da requisição</label>
          <select class="form-control input-validate" name="requisicao" id="requisicao"
            [formControl]="formDados.controls.tipoRequisicao">
            <option value="">Selecione</option>
            <option *ngFor="let t of listaTipoRequisicao" [value]="t.id">{{ t.tipoRequisicao | uppercase}}</option>
          </select>
          <app-msg-erro [control]="formDados.controls.tipoRequisicao"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-6 p-2">
          <label for="url">URL</label>
          <input type="text" autocomplete="false" placeholder="https://" class="form-control input-validate" name="url"
            id="url" [formControl]="formDados.controls.url">
          <app-msg-erro [control]="formDados.controls.url"></app-msg-erro>
        </div>
      </div>
    </div>
    <div class="card-header mt-4 bg-white">
      <h3>Parâmetros da consulta</h3>
    </div>
    <div class="card-body">
      <div class="row mb-4">
        <div class="col p-2">
          <label for="chaveParametros">Chave</label>
          <input type="text" autocomplete="false" class="form-control input-validate" name="chaveParametros"
            id="chaveParametros" [formControl]="formParametrosConsulta.controls.chave">
            <app-msg-erro [control]="formParametrosConsulta.controls.chave"></app-msg-erro>
        </div>
        <div class="col p-2">
          <label for="valorParametros">Valor</label>
          <input type="text" autocomplete="false" class="form-control input-validate" name="valorParametros"
            id="valorParametros" [formControl]="formParametrosConsulta.controls.valor">
            <app-msg-erro [control]="formParametrosConsulta.controls.valor"></app-msg-erro>
        </div>
        <div class="col p-2">
          <label for="tipoEnvioParametros">Tipo de envio</label>
          <select class="form-control input-validate" name="tipoEnvioParametros" id="tipoEnvioParametros" [formControl]="formParametrosConsulta.controls.tipoEnvio">
            <option value="">Selecione</option>
            <option *ngFor="let te of listaEnvioParamsConsulta" [value]="te.id">{{ te.tipoEnvioParametro | uppercase}}</option>
          </select>
        </div>
        <div class="col-lg-1 p-2 m-auto m-20px">
          <button class="btn btn-sm btn-icon btn-success rounded-circle m-auto" (click)="addParamConsulta()">
            <i class="mdi mdi-plus"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-12 p-2">
          <table class="table bg-light rounded">
            <thead class="text-center" *ngIf="listaParamsConsulta.length > 0">
              <tr>
                <th>Chave</th>
                <th>Valor</th>
                <th>Envio</th>
                <th class="acao-tabela">Ações</th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr *ngIf="listaParamsConsulta.length == 0">
                <td class="text-center py-5 text-secondary w-500" colspan="7">
                  Sem registros
                </td>
              </tr>
              <tr *ngFor="let l of listaParamsConsulta">
                <td>{{ l.chave }}</td>
                <td>{{ l.valor }}</td>
                <td>{{ l.envio }}</td>
                <td class="d-flex align-items-center justify-content-end">
                  <span data-toggle="tooltip" data-placement="bottom" title="Editar">
                  <button (click)="editParamConsulta(l.id)" class="btn btn-sm btn-icon btn-primary" title="EDITAR">
                    <i class="mdi mdi-pencil"></i>
                  </button></span>
                  <span data-toggle="tooltip" data-placement="bottom" title="Excluir">
                  <button (click)="delParamConsulta(l.id)" class="btn btn-sm btn-danger btn-icon mx-1" title="DELETAR">
                    <i class="mdi mdi-delete"></i>
                  </button></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- <div *ngIf="listaParamsConsulta.length > 0" class="card-footer bg-white row justify-content-between">
        <div class="mt-2 mt-md-0">
          <ngb-pagination [pageSize]="filter.per_page" [boundaryLinks]="true" [collectionSize]="totalParamsConsultas"
            [(page)]="filter.page" (pageChange)="nextPage()" [maxSize]="5" [rotate]="true">
          </ngb-pagination>
        </div>
        <div class="btn-group mt-2 mt-md-0" role="group" aria-label="Basic example">
          <button [disabled]="totalParamsConsultas==0" (click)="setPageSize(10)" [ngClass]="{'active': filter.per_page==10}"
            type="button" class="btn btn-outline-primary">10</button>
          <button [disabled]="totalParamsConsultas==0" (click)="setPageSize(25)" [ngClass]="{'active':  filter.per_page==25}"
            type="button" class="btn btn-outline-primary">25</button>
          <button [disabled]="totalParamsConsultas==0" (click)="setPageSize(50)" [ngClass]="{'active':  filter.per_page==50}"
            type="button" class="btn btn-outline-primary">50</button>
          <button [disabled]="totalParamsConsultas==0" (click)="setPageSize(100)" [ngClass]="{'active':  filter.per_page==100}"
            type="button" class="btn btn-outline-primary">100</button>
        </div>
      </div> -->
    </div>
    <div class="card-header mt-4 bg-white">
      <h3>Parâmetros Extras</h3>
    </div>
    <div class="card-body">
      <div class="row mb-4">
        <div class="col p-2">
          <label for="chaveParametrosExtra">Chave</label>
          <input type="text" autocomplete="false" class="form-control input-validate" name="chaveParametrosExtra"
            id="chaveParametrosExtra" [formControl]="formParametrosConsultaExtra.controls.chave">
            <app-msg-erro [control]="formParametrosConsultaExtra.controls.chave"></app-msg-erro>
        </div>
        <div class="col p-2">
          <label for="pesquisaParametrosExtra">Pesquisa</label>
          <select class="form-control input-validate" name="pesquisaParametrosExtra" id="pesquisaParametrosExtra" [formControl]="formParametrosConsultaExtra.controls.pesquisa">
            <option value="">Selecione</option>
            <option *ngFor="let p of listaCampoPesquisa" [value]="p.id">{{ p.campoPesquisa | uppercase}}</option>
          </select>
        </div>
        <div class="col p-2">
          <label for="tipoEnvioParametrosExtra">Tipo de envio</label>
          <select class="form-control input-validate" name="tipoEnvioParametrosExtra" id="tipoEnvioParametrosExtra" [formControl]="formParametrosConsultaExtra.controls.tipoEnvio">
            <option value="">Selecione</option>
            <option *ngFor="let te of listaEnvioParamsConsultaExtra" [value]="te.id">{{ te.tipoEnvioParametro | uppercase}}</option>
          </select>
        </div>
        <div class="col-lg-1 p-2 m-auto m-20px">
          <button class="btn btn-sm btn-icon btn-success rounded-circle m-auto" (click)="addParamConsultaExtra()">
            <i class="mdi mdi-plus"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-12 p-2">
          <table class="table bg-light rounded">
            <thead class="text-center" *ngIf="listaParamsConsultaExtra.length > 0">
              <tr>
                <th>Chave</th>
                <th>Pesquisa</th>
                <th>Envio</th>
                <th class="acao-tabela">Ações</th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr *ngIf="listaParamsConsultaExtra.length==0">
                <td class="text-center py-5 text-secondary w-500" colspan="7">
                  Sem registros
                </td>
              </tr>
              <tr *ngFor="let e of listaParamsConsultaExtra">
                <td>{{ e.chave }}</td>
                <td>{{ e.pesquisa }}</td>
                <td>{{ e.envio }}</td>
                <td class="d-flex align-items-center justify-content-end">
                  <span data-toggle="tooltip" data-placement="bottom" title="Editar">
                  <button (click)="editParamConsultaExtra(e.id)" class="btn btn-sm btn-icon btn-primary" title="EDITAR">
                    <i class="mdi mdi-pencil"></i>
                  </button></span>
                  <span data-toggle="tooltip" data-placement="bottom" title="Excluir">
                  <button (click)="delParamConsultaExtra(e.id)" class="btn btn-sm btn-danger btn-icon mx-1" title="DELETAR">
                    <i class="mdi mdi-delete"></i>
                  </button></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- <div *ngIf="listaParamsConsultaExtra.length > 0" class="card-footer bg-white row justify-content-between">
        <div class="mt-2 mt-md-0">
          <ngb-pagination [pageSize]="filter.per_page" [boundaryLinks]="true" [collectionSize]="total"
            [(page)]="filter.page" (pageChange)="nextPage()" [maxSize]="5" [rotate]="true">
          </ngb-pagination>
        </div>
        <div class="btn-group mt-2 mt-md-0" role="group" aria-label="Basic example">
          <button [disabled]="total==0" (click)="setPageSize(10)" [ngClass]="{'active':  filter.per_page==10}"
            type="button" class="btn btn-outline-primary">10</button>
          <button [disabled]="total==0" (click)="setPageSize(25)" [ngClass]="{'active':  filter.per_page==25}"
            type="button" class="btn btn-outline-primary">25</button>
          <button [disabled]="total==0" (click)="setPageSize(50)" [ngClass]="{'active':  filter.per_page==50}"
            type="button" class="btn btn-outline-primary">50</button>
          <button [disabled]="total==0" (click)="setPageSize(100)" [ngClass]="{'active':  filter.per_page==100}"
            type="button" class="btn btn-outline-primary">100</button>
        </div>
      </div> -->
    </div>
    <div class="d-flex justify-content-end card-footer bg-white text-muted mx-xl-4">
      <button class="btn btn-lg px-5 btn-success" [disabled]="formDados.invalid" (click)="submitForm()">
        <span>Salvar</span>
      </button>
    </div>
  </div>
</section>